import React, { useState, useRef, } from "react";
import { Box, Button, Grid2, InputBase, Skeleton, Typography, Alert, Avatar, Stack, Chip, Paper, Divider, Modal } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useEffect } from 'react';
import Header from "../Layout/Header/Header";
import PropTypes from 'prop-types';
import './swap.css';
import Container from '@mui/material/Container';
import Menu from '@mui/material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Inr from '../../Images/inr.png';
import Usd from '../../Images/usd.png';
import { useDispatch, useSelector } from "react-redux";
import { ToastError, ToastSuccess } from "../../CustomToaster/CustomToaster";
import { InputError } from "../Errors/ErrorText";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllTradePairList } from "../../Actions/TradePairs/TradePairAction";
import { handleImageError, toFixed } from "../../Helper/helper";
import { createInvestment } from "../../Services/investmentService";
import { getWalletSummary } from "../../Actions/PortfolioAction";
import socket from "../../utils/Socket";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '300px', md: '450px' },
    bgcolor: 'var(--color-BasicBg)',
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
};

// Search
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'var(--color-BasicBg)',
    '&:hover': {
        background: 'none',
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '200px',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(0),
        width: '200px',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // background: 'var(--color-CardBg)',
    color: 'var(--color-PrimaryText)',
    borderRadius: '5px'
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing('4px 8px 4px 20px'),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        // border: '1px solid var(--color-Line)',
        border: "1px solid var(--color-InputLine)",
        borderRadius: '5px',
        [theme.breakpoints.up('md')]: {
            width: '200px',
        },
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 2, mt: 1 }}>{children}</Box>}
        </div>
    );
}

const networkOptions = [


    {
        title: 'USDT',
        balance: '$0.00',
        description: 'United States Dollar',
        confirmations: '12 confirmations',
        img: Usd,
    },
    {
        title: 'INR',
        balance: '₹0.00',
        description: 'Indian Rupee',
        confirmations: '15 confirmations',
        img: Inr,
    },


];

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function InvestmentCrypto() {

    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const initialSymbol = queryParams.get("symbol");

    const [reviewDetailsOpen, setReviewDetailsOpen] = React.useState(false);
    const handleReviewDetailsOpen = () => setReviewDetailsOpen(true);
    const handleReviewDetailsClose = () => setReviewDetailsOpen(false);

    const { userDetailData } = useSelector((state) => state.user);
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { tradePairLoading, tradePairData } = useSelector((state) => state.tradePair);
    const { assets, totalCryptoBalanceUSDT = 0, loading: portfolioLoading } = useSelector((state) => state.portfolio);

    // Lock price
    const PRICE_LOCK_SECONDS = 15;

    const [lockedPrice, setLockedPrice] = useState(null);
    const [timer, setTimer] = useState(PRICE_LOCK_SECONDS);
    const timerRef = useRef(null);
    const [selectedReceiveCurrency, setSelectedReceiveCurrency] = useState({});
    const [livePrice, setLivePrice] = useState(null);
    const [receiveSearchQuery, setReceiveSearchQuery] = useState("");

    // Spend 
    const spendBtnRef = useRef();
    const [spendMenuWidth, setSpendMenuWidth] = useState(null);
    const [Update, setUpdate] = useState(false)

    // Receive 
    const receiveBtnRef = useRef();
    const [receiveMenuWidth, setReceiveMenuWidth] = useState(null);
    const [transactionDetail, setTransactionDetail] = useState({
        type: 'buy',
        baseCurrency: 'USDT',
        quoteCurrency: 'BTC',
        baseAmount: '',
        quoteAmount: '',
        symbol: 'USDT',
        image: '',
        adminBankId: '',
        userBankId: ''
    });
    const [errors, setErrors] = useState({});
    const [pairDetail, setPairDetail] = useState(null);
    const [receivePairList, setReceivePairList] = useState([]);
    const [userBalance, setUserBalance] = useState(null);
    const [isBuyFormLoading, setIsBuyFormLoading] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const open1 = Boolean(anchorEl1);

    useEffect(() => {
        const handler = (data) => {
            if (selectedReceiveCurrency?.symbol === data.symbol) {
                setLivePrice(data.lastPrice);
            }

            if (tradePairLoading) return;

            setReceivePairList(prev => {
                const index = prev.findIndex(t => t.symbol === data.symbol);
                if (index === -1) return prev;
                const updated = [...prev];
                updated[index] = { ...updated[index], ...data, lastPrice: data.lastPrice };
                return updated;
            });
        };

        socket.on("live_ticker_update", handler);

        return () => {
            socket.off("live_ticker_update", handler);
        };
    }, [selectedReceiveCurrency?.symbol, tradePairLoading]);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClose1 = () => {
        setAnchorEl1(null);
    };

    const handleReceiveSearchChange = (event) => {
        const { value } = event.target;
        setReceiveSearchQuery(value);
    };

    useEffect(() => {
        if (spendBtnRef.current) {
            setSpendMenuWidth(spendBtnRef.current.offsetWidth);
        }
    }, [Update]);

    // Price lock
    const lockPrice = (price) => {
        if (!price) return;

        setLockedPrice(price);
        setTimer(PRICE_LOCK_SECONDS);

        clearInterval(timerRef.current);

        timerRef.current = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        if (!tradePairData?.data || tradePairData?.data?.length <= 10) {
            dispatch(getAllTradePairList({ type: 'all' }));
        }
        if (isAuthenticated && userDetailData?._id) {
            dispatch(getWalletSummary(userDetailData?._id));
        }
    }, [isAuthenticated, userDetailData?._id]);

    useEffect(() => {
        if (receiveBtnRef.current) {
            setReceiveMenuWidth(receiveBtnRef.current.offsetWidth);
        }
    }, []);

    useEffect(() => {
        if (livePrice && !lockedPrice) {
            lockPrice(livePrice);
        }
    }, [livePrice]);

    useEffect(() => {
        if (timer === 0 && livePrice) {
            lockPrice(livePrice);
        }
    }, [timer, livePrice]);

    useEffect(() => {
        if (!tradePairLoading && selectedReceiveCurrency?.lastPrice) {
            setLockedPrice(selectedReceiveCurrency?.lastPrice);
            lockPrice(selectedReceiveCurrency?.lastPrice);
            setTimer(PRICE_LOCK_SECONDS);
        }
    }, [selectedReceiveCurrency?.symbol, tradePairLoading]);

    // Price Lock
    useEffect(() => {
        if (tradePairLoading) return;

        if (livePrice) {
            lockPrice(livePrice);
        }

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [selectedReceiveCurrency?.symbol, tradePairLoading]);

    useEffect(() => {
        if (portfolioLoading) return;

        setUserBalance(toFixed(assets?.USDT?.quantity || 0, 4));
    }, [portfolioLoading, totalCryptoBalanceUSDT])

    useEffect(() => {
        if (!tradePairLoading && tradePairData) {
            setPairDetail(tradePairData);
            const receivePairs = tradePairData?.data?.filter((item) => item?.coinTwo === "USDT")
            setReceivePairList(receivePairs);
            if (initialSymbol) {
                const selectedPair = receivePairs?.find((item) => item?.coinOne?.toLowerCase() === initialSymbol?.toLowerCase());
                setSelectedReceiveCurrency(selectedPair)
            } else {
                setSelectedReceiveCurrency(receivePairs?.[0])
            }
        }
    }, [tradePairLoading, tradePairData]);

    useEffect(() => {
        if (!tradePairLoading && tradePairData) {
            if (receiveSearchQuery) {
                const filteredPairs = tradePairData?.data?.filter((item) => item?.coinTwo === "USDT" && item?.coinOne?.toLowerCase()?.includes(receiveSearchQuery?.toLowerCase()));
                setReceivePairList(filteredPairs);
            } else {
                setReceivePairList(tradePairData?.data?.filter((item) => item?.coinTwo === "USDT"));
            }
        }
    }, [receiveSearchQuery])

    const handleReceiveCurrencyChange = (option) => {
        setSelectedReceiveCurrency(option);
        setLivePrice(option?.lastPrice);
        handleClose1();
        setReceiveSearchQuery("");
        setTransactionDetail(prev => ({ ...prev, baseAmount: "", quoteAmount: "" }));
        navigate(`/investment?symbol=${option.coinOne}`, { replace: true });
    }

    const handleAmountChange = (e) => {
        let value = e.target.value;

        const price = Number(lockedPrice ?? livePrice ?? 0);
        const qtyDecimal = selectedReceiveCurrency?.qtyDecimal ?? 8;
        // const qtyDecimal = 4;

        // Reset
        if (value === "") {
            setTransactionDetail(prev => ({ ...prev, baseAmount: "", quoteAmount: "" }));
            return;
        }

        // Max 8 digits before and after decimal, no leading zeros
        const regex = /^(0|[1-9]\d{0,7})(\.\d{0,4})?$/;
        if (!regex.test(value)) return;

        // Prevent invalid price
        if (!price || !Number.isFinite(price)) {
            setTransactionDetail(prev => ({ ...prev, baseAmount: value, quoteAmount: "" }));
            return;
        }

        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return;
        toFixed(1 / (lockedPrice ?? livePrice ?? 1), 8)
        const calculatedQuote = toFixed(numericValue / (lockedPrice ?? livePrice ?? 1), qtyDecimal);
        // Balance validation
        if (numericValue > Number(userBalance || 0)) {
            setErrors(prev => ({ ...prev, baseAmount: "Insufficient balance" }));
        } else {
            setErrors(prev => ({ ...prev, baseAmount: "" }));
        }
        setTransactionDetail(prev => ({ ...prev, baseAmount: value, quoteAmount: calculatedQuote }));
    };

    const validateForm = () => {
        const errors = {};

        const price = Number(pairDetail?.buyPrice || 0);
        const minBuy = Number(pairDetail?.minBuyValue || 0);
        const maxBuy = Number(pairDetail?.maxBuyValue || 0);

        const baseAmount = Number(transactionDetail.baseAmount || 0);
        const quoteAmount = Number(transactionDetail.quoteAmount || 0);

        // Common validation
        if (!baseAmount) {
            errors.baseAmount = "Enter the amount";
        }

        // Balance validation
        if (transactionDetail.type === "buy" && baseAmount > userBalance) {
            errors.baseAmount = "Insufficient balance";
        }

        // BUY validation
        if (transactionDetail.type === "buy") {

            // Min validation (quote currency)
            if (minBuy && quoteAmount < minBuy) {
                const minBase = minBuy / price;
                errors.baseAmount = `Minimum ${minBase.toFixed(2)} ${transactionDetail.baseCurrency} required`;
            }

            // Max validation
            if (maxBuy && quoteAmount > maxBuy) {
                const maxBase = maxBuy / price;
                errors.baseAmount = `Maximum ${maxBase.toFixed(2)} ${transactionDetail.baseCurrency} allowed`;
            }
        }

        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return true;
        }

        return false;
    }

    const resetForm = () => {
        setTransactionDetail((prev) => ({ ...prev, baseAmount: "", quoteAmount: "" }));
    }

    const handleFormSubmit = async () => {

        if (validateForm()) return;

        setErrors({});

        try {
            setIsBuyFormLoading(true);
            const payload = {
                pair: selectedReceiveCurrency?.symbol,
                value: transactionDetail.baseAmount,
                price: lockedPrice ?? livePrice,
            };
            const response = await createInvestment(payload);
            if (response.status === 200 && response.data.success) {
                resetForm();
                setUserBalance(prev => toFixed(Number(prev) - Number(transactionDetail.baseAmount), 4));
                ToastSuccess({ message: response.data.message });
            } else {
                ToastError({ message: response.data.message || 'Something went wrong' });
            }
        } catch (err) {
            ToastError({ message: "Something went wrong" });
        } finally {
            setIsBuyFormLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <Container maxWidth="lg">
                <Box sx={{ display: "block", padding: "20px", marginBottom: "80px" }} className="swap-main-box">
                    <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            {/* Investment */}
                            <Box className="bdr-bx " id="swap-id" sx={{ padding: '25px !important' }}>
                                <Box className="swap-container" sx={{ borderBottom: 1, borderColor: 'divider', }}>
                                    <Typography variant="h3" textAlign="center" >Investment</Typography>
                                </Box>

                                <>
                                    {/* Spend */}
                                    <div className='nwt-btn mt-10 crr-btn crtp-btn'>
                                        <div
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            sx={{ width: "100%", display: "block" }}
                                            className='mn-btn mt-20 b-s-inpt'
                                            ref={spendBtnRef}
                                        >
                                            < div className="by-sl" >
                                                <p className="text-left">Spend</p>
                                                <div className='display-2 options-mnu' style={{ flexGrow: 1 }} >
                                                    <TextField
                                                        type="text"
                                                        sx={{ padding: "0px", width: "85%" }}
                                                        placeholder="1 USDT"
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        value={transactionDetail?.baseAmount}
                                                        onChange={handleAmountChange}
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    {tradePairLoading ? <Skeleton variant="rectangular" sx={{ borderRadius: "5px", backgroundColor: "#2b3139" }} width={100} height={40} /> :
                                                        <div className='display-4'>
                                                            <img width={20} src={networkOptions[0]?.img} />
                                                            <p>{networkOptions[0]?.title}</p>
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        {(userBalance !== null && userBalance !== undefined && !tradePairLoading) && <p style={{ marginTop: 3 }}>You have {userBalance || 0} {networkOptions[0]?.title}</p>}
                                        <InputError error={errors?.baseAmount} />

                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                                            PaperProps={{
                                                sx: {
                                                    backgroundColor: 'var(--color-CardBg)',
                                                    color: 'var(--color-PrimaryText)',
                                                    '& .MuiMenuItem-root:hover': {
                                                        backgroundColor: 'var(--color-Input)',
                                                    },
                                                    width: spendMenuWidth,
                                                },
                                            }}
                                            className='cp-mn'
                                        >
                                            <MenuItem
                                                value=""
                                                sx={{
                                                    fontSize: '12px',
                                                    color: 'var(--color-PrimaryText)',
                                                    textAlign: 'start',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: "0px 3px "
                                                }}
                                            >
                                            </MenuItem>
                                            {networkOptions.map((option, index) => (
                                                <MenuItem key={index} onClick={handleClose}>
                                                    <div className='display-1' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <img width="30px" src={option.img} alt={option.title} />
                                                        <div>
                                                            <p>{option.title}</p>
                                                            <p style={{ fontSize: '12px' }}>{option.description}</p>
                                                        </div>
                                                    </div>
                                                </MenuItem>
                                            ))}

                                        </Menu>
                                    </div>

                                    {/* Price lock */}
                                    <Box sx={{ mt: 2, mb: 2, p: 1.5, borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", background: "linear-gradient(90deg,#1a1a1a,#2a2a2a)", border: "1px solid #333" }} >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Typography sx={{ fontSize: 14 }}>🔒 Price Locked</Typography>

                                            <Tooltip
                                                arrow
                                                placement="top"
                                                title="The exchange rate is locked for a short time to protect you from market price changes. When the timer ends, a new market price will be applied."
                                            >
                                                <IconButton size="small" sx={{ color: "#aaa" }}>
                                                    <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>

                                        <Typography sx={{ fontSize: 14 }}>
                                            Resets in <b>{timer}s</b>
                                        </Typography>
                                    </Box>

                                    {/* Receive */}
                                    <div className='nwt-btn mt-10 crr-btn crtp-btn'>
                                        <div
                                            id="basic-button1"
                                            aria-controls={open1 ? 'basic-menu1' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open1 ? 'true' : undefined}
                                            sx={{ width: "100%", display: "block" }}
                                            className='mn-btn mt-20 b-s-inpt'
                                            ref={receiveBtnRef}
                                        >
                                            <div className="by-sl">
                                                <p className="text-left">Receive</p>
                                                <div className='display-2 options-mnu' style={{ flexGrow: 1 }} >
                                                    <TextField type="number" placeholder="0" id="outlined-basic" variant="outlined"
                                                        value={transactionDetail?.quoteAmount}
                                                        disabled
                                                        sx={{
                                                            padding: "0px",
                                                            "& .MuiInputBase-input": {
                                                                color: "#fff",
                                                            },
                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                WebkitTextFillColor: "#fff",
                                                            },
                                                        }}
                                                    />
                                                    {tradePairLoading ? <Skeleton variant="rectangular" sx={{ borderRadius: "5px" }} width={100} height={40} /> :
                                                        <div className='display-4 cursor' style={{ padding: '5px', backgroundColor: "#a4a4a447", borderRadius: "5px" }} onClick={() => setAnchorEl1(receiveBtnRef.current)}>
                                                            <img width={20} src={selectedReceiveCurrency?.baseImage} onError={handleImageError} />
                                                            <p>{selectedReceiveCurrency?.coinOne}</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {selectedReceiveCurrency?.coinOne && <p style={{ marginTop: 3 }}>1 USDT = {toFixed(1 / (lockedPrice ?? livePrice ?? 1), selectedReceiveCurrency?.qtyDecimal || 8)} {selectedReceiveCurrency?.coinOne}</p>}

                                        <Menu
                                            id="basic-menu1"
                                            className='cp-mn'
                                            anchorEl={anchorEl1}
                                            open={open1}
                                            autoFocus={false}
                                            disableAutoFocusItem
                                            onClose={handleClose1}
                                            MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                                            PaperProps={{
                                                sx: {
                                                    backgroundColor: 'var(--color-CardBg)',
                                                    color: 'var(--color-PrimaryText)',
                                                    '& .MuiMenuItem-root:hover': {
                                                        backgroundColor: 'var(--color-Input)',
                                                    },
                                                    maxHeight: '350px',
                                                    width: receiveMenuWidth,

                                                },
                                            }}
                                        >
                                            <MenuItem
                                                value=""
                                                sx={{
                                                    fontSize: '12px',
                                                    color: 'var(--color-PrimaryText)',
                                                    textAlign: 'start',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: "0px 3px "
                                                }}
                                            >
                                                <div className="category-search-box-car1 srch" style={{ placeContent: "center" }}>
                                                    <Search className='search-crs' >
                                                        <SearchIconWrapper>
                                                            <SearchIcon sx={{ color: 'var(--color-PrimaryText)' }} />
                                                        </SearchIconWrapper>
                                                        <StyledInputBase
                                                            sx={{ width: '100%' }}
                                                            placeholder="Search"
                                                            inputProps={{ 'aria-label': 'search' }}
                                                            value={receiveSearchQuery}
                                                            onChange={handleReceiveSearchChange}
                                                            onKeyDown={(e) => e.stopPropagation()}
                                                        />
                                                    </Search>
                                                </div>
                                            </MenuItem>

                                            {receivePairList?.length > 0 ?
                                                receivePairList?.map((option, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        selected={selectedReceiveCurrency?.coinOne === option.coinOne}
                                                        onClick={() => handleReceiveCurrencyChange(option)}
                                                    >
                                                        <div className='display-1' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <img width="30px" src={option.baseImage} alt={option.coinOne} onError={handleImageError} />
                                                            <div>
                                                                <p>{option.coinOne}</p>
                                                                <p style={{ fontSize: '12px' }}>{option.description}</p>
                                                            </div>
                                                        </div>
                                                    </MenuItem>
                                                ))
                                                : <MenuItem sx={{ fontSize: '12px' }} disabled>
                                                    <p>No Data Found</p>
                                                </MenuItem>
                                            }
                                        </Menu>
                                    </div>

                                    {/* Buy Form Submit */}
                                    <div className="blu-btn display-3 mt-30">
                                        <Button sx={{ width: "100%" }} disabled={timer === 0 || isBuyFormLoading || tradePairLoading} onClick={handleFormSubmit}>{isBuyFormLoading ? "Progressing..." : "Invest"}</Button>
                                    </div>

                                    {/* <div className="blu-btn display-3 mt-30">
                                            <Button sx={{ width: "100%" }} onClick={handleReviewDetailsOpen}>Invest</Button>
                                    </div> */}
                                </>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Modal
                open={reviewDetailsOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="res-modal">
                    <div className="display-2">
                        <h2 className="gold-color" style={{ fontWeight: 900 }}>Review details</h2>
                        <CancelRoundedIcon onClick={() => { handleReviewDetailsClose() }} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                    </div>

                    <div className="input-common mt-10">
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1,
                                background: "transparent",
                            }}
                        >
                            {/* Warning */}
                            <Alert
                                severity="warning"
                                icon={false}
                                sx={{
                                    mb: 3,
                                    background: "#E8DCC6",
                                    color: "#333",
                                    borderRadius: 2,
                                    fontSize: 14,
                                }}
                            >
                                ⚠️ Insufficient balance. Please deposit funds to your account.
                            </Alert>

                            {/* FROM */}
                            <Stack direction="row" justifyContent="space-between" mb={2}>
                                <Box>
                                    <Typography variant="body2" >
                                        From
                                    </Typography>

                                    <Stack direction="row" spacing={1} alignItems="center" mt={1}>
                                        <Avatar
                                            sx={{
                                                bgcolor: "#F7931A",
                                                width: 36,
                                                height: 36,
                                                fontWeight: 700,
                                            }}
                                        >
                                            ₿
                                        </Avatar>

                                        <Typography fontWeight={600}>BTC</Typography>
                                    </Stack>
                                </Box>

                                <Typography fontWeight={600} fontSize={18}>
                                    0.5
                                </Typography>
                            </Stack>

                            {/* TO */}
                            <Stack direction="row" justifyContent="space-between" mb={3}>
                                <Box>
                                    <Typography variant="body2" >
                                        To
                                    </Typography>

                                    <Stack direction="row" spacing={1} alignItems="center" mt={1}>
                                        <Avatar
                                            sx={{
                                                bgcolor: "#26A17B",
                                                width: 36,
                                                height: 36,
                                                fontWeight: 700,
                                            }}
                                        >
                                            ₮
                                        </Avatar>

                                        <Typography fontWeight={600}>USDT</Typography>
                                    </Stack>
                                </Box>

                                <Typography fontWeight={600} fontSize={18}>
                                    32,632.6429
                                </Typography>
                            </Stack>

                            <Divider sx={{ my: 2 }} />

                            {/* PRICE */}
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={2}
                            >
                                <Typography >Price</Typography>

                                <Typography fontWeight={500}>
                                    1 BTC ≈ 65,265.2859 USDT
                                </Typography>
                            </Stack>

                            {/* FEE */}
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography >Fee</Typography>

                                <Chip
                                    label="0 Fee"
                                    size="small"
                                    sx={{
                                        background: "#059669",
                                        fontWeight: 600,
                                    }}
                                />
                            </Stack>
                        </Paper>
                    </div>


                    <div className="blu-btn text-center mt-20">
                        <Button fullWidth>Deposit</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default InvestmentCrypto;
